/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeForm4506TStep2Page() {
      // --------------------------------------------------------------------------
      // initialize the validation engine
      // --------------------------------------------------------------------------
      var onSubmit = false;
      customValidationInit(onSubmit);
      aspControlValidationInit();

      //$("[id$='divTaxReturn1040']").hide();
      //$("[id$='questionContainer']").hide();
      //$("[id$='question6']").hide();
      //$("[id$='question7']").hide();
      //$("[id$='question8']").hide();
      //$("[id$='question9']").hide();
      //$("[id$='buttons']").hide();

      // init tax filing divs
      var loadData;
      loadData = $("[id$='hdnLoadData']").val();

      if (loadData == "N") {
         $("[id$='divTaxReturn1040']").hide();
         $("[id$='questionContainer']").hide();
         $("[id$='question6']").hide();
         $("[id$='question7']").hide();
         $("[id$='question8']").hide();
         $("[id$='question9']").hide();
         $("[id$='buttons']").hide();
      } else if (loadData == "6") {
         $("[id$='divTaxReturn1040']").show();
         $("[id$='questionContainer']").show();
         $("[id$='question6']").show();
         $("[id$='question7']").hide();
         $("[id$='question8']").hide();
         $("[id$='question9']").show();
         $("[id$='buttons']").show();
         $("[id$='rblTaxFilingLastThreeYears']").find("input[value='Y']").prop("checked", true);
         $("[id$='rblTaxReturn1040']").find("input[value='Y']").prop("checked", true);
      } else if (loadData == "7") {
         $("[id$='divTaxReturn1040']").hide();
         $("[id$='questionContainer']").show();
         $("[id$='question6']").hide();
         $("[id$='question7']").show();
         $("[id$='question8']").hide();
         $("[id$='question9']").show();
         $("[id$='buttons']").show();
         $("[id$='rblTaxFilingLastThreeYears']").find("input[value='N']").prop("checked", true);
      } else if (loadData == "8") {
         $("[id$='divTaxReturn1040']").show();
         $("[id$='questionContainer']").show();
         $("[id$='question6']").hide();
         $("[id$='question7']").hide();
         $("[id$='question8']").show();
         $("[id$='question9']").show();
         $("[id$='buttons']").show();
         $("[id$='rblTaxFilingLastThreeYears']").find("input[value='Y']").prop("checked", true);
         $("[id$='rblTaxReturn1040']").find("input[value='N']").prop("checked", true);
     }

      checkBoxEvents();
      
      // tax filing radio button event handler
      $("[id$='rblTaxFilingLastThreeYears']").change(function () {
         var selectedValue = $("[id$='rblTaxFilingLastThreeYears'] input:checked").val();

         if (selectedValue == "Y") {
            // show second question
            $("[id$='divTaxReturn1040']").show();
            $("[id$='rblTaxReturn1040'] input").prop("checked", false);

            // hide all the 6-9
            $("[id$='questionContainer']").hide();
            $("[id$='question6']").hide();
            $("[id$='question7']").hide();
            $("[id$='question8']").hide();
            $("[id$='question9']").hide();

            // reset inputs 6-9
            $("[id$='txtTranscriptRequested']").val("");
            $("[id$='chk6a']").prop('checked', false);
            $("[id$='chk6b']").prop('checked', false);
            $("[id$='chk6c']").prop('checked', false);
            $("[id$='hdnQuestion7']").val("");
            $("[id$='hdnQuestion8']").val("");
         }
         else if (selectedValue == "N") {
            // show 7 and 9
            $("[id$='questionContainer']").show();
            $("[id$='question7']").show();
            $("[id$='question9']").show();
            $("[id$='buttons']").show();
            $("[id$='hdnQuestion7']").val("Y");

            // hide second question and 6 and 8
            $("[id$='divTaxReturn1040']").hide();
            $("[id$='question6']").hide();
            $("[id$='question8']").hide();

            // reset inputs 6 and 8
            $("[id$='txtTranscriptRequested']").val("");
            $("[id$='chk6a']").prop('checked', false);
            $("[id$='chk6b']").prop('checked', false);
            $("[id$='chk6c']").prop('checked', false);
            $("[id$='hdnQuestion8']").val("");
         }
      });

      // tax filing radio button event handler
      $("[id$='rblTaxReturn1040']").change(function () {
         var selectedValue = $("[id$='rblTaxReturn1040'] input:checked").val();

         if (selectedValue == "Y") {
            // show 6 and 9
            $("[id$='questionContainer']").show();
            $("[id$='question6']").show();
            $("[id$='question9']").show();
            $("[id$='buttons']").show();

            // pre-populate 6
            $("[id$='txtTranscriptRequested']").val("1040");
            $("[id$='chk6a']").prop('checked', true);
            $("[id$='chk6b']").prop('checked', false);
            $("[id$='chk6c']").prop('checked', false);

            // hide 7 and 8
            $("[id$='question7']").hide();
            $("[id$='question8']").hide();

            // reset 7 and 8
            $("[id$='hdnQuestion7']").val("");
            $("[id$='hdnQuestion8']").val("");
         }
         else if (selectedValue == "N") {
            // show 8 and 9
            $("[id$='questionContainer']").show();
            $("[id$='question8']").show();
            $("[id$='question9']").show();
            $("[id$='buttons']").show();
            $("[id$='hdnQuestion8']").val("Y");

            // hide 6 and 7
            $("[id$='question6']").hide();
            $("[id$='question7']").hide();

            // reset 6 and 7
            $("[id$='txtTranscriptRequested']").val("");
            $("[id$='chk6a']").prop('checked', false);
            $("[id$='chk6b']").prop('checked', false);
            $("[id$='chk6c']").prop('checked', false);
            $("[id$='hdnQuestion7']").val("");
         }
      });
}

function checkBoxEvents() {
   // only 1 of the question 6, 7, or 8 can be selected
   // if question 6 is selected then only 1 of the question 6 option checkboxes (6a, 6b, 6c) can be selected at a time

   // 6a checked so uncheck 6b, 6c, 7, and 8
   $("[id$='chk6a']").click(function () {
      if ($(this).is(":checked")) {
         $("[id$='chk6b']").prop('checked', false);
         $("[id$='chk6c']").prop('checked', false);
      }
   });
   // 6b checked so uncheck 6a, 6c, 7, and 8
   $("[id$='chk6b']").click(function () {
      if ($(this).is(":checked")) {
         $("[id$='chk6a']").prop('checked', false);
         $("[id$='chk6c']").prop('checked', false);
      }
   });
   // 6c checked so uncheck 6a, 6b, 7, and 8
   $("[id$='chk6c']").click(function () {
      if ($(this).is(":checked")) {
         $("[id$='chk6a']").prop('checked', false);
         $("[id$='chk6b']").prop('checked', false);
      }
   });

}

// step 2 page submit - validate function
export function validateForm4506T() {
  const question6 = $("[id$='txtTranscriptRequested']");
  const question6a = $("[id$='chk6a']");
  const question6b = $("[id$='chk6b']");
  const question6c = $("[id$='chk6c']");
  const question7 = $("[id$='hdnQuestion7']");
  const question8 = $("[id$='hdnQuestion8']");

  let question6HasValue = false;
  let question7HasValue = false;
  let question8HasValue = false;
  let isValid = true;

   // Either 6, 7, or 8 is required
   if (question6.val().length > 0) {
      if ((question6a.is(":checked") == true) ||
         (question6b.is(":checked") == true) ||
         (question6c.is(":checked") == true)) {
         question6HasValue = true;
      } else {
         $("#question6").validationEngine('showPrompt', 'Please enter an option (a, b, or c) for Question 6', 'error', 'topLeft', false);   
         isValid = false;
      }
   }
   if ((question6a.is(":checked") == true) ||
      (question6b.is(":checked") == true) ||
      (question6c.is(":checked") == true)) {
      if (question6.val().length == 0) {
         $("#question6").validationEngine('showPrompt', 'Please enter which tax form number you are requesting.', 'error', 'topLeft', false);
         isValid = false;
      }
   }
   if (question7.val().length > 0) {
      question7HasValue = true;
   }
   if (question8.val().length > 0) {
      question8HasValue = true;
   }

   if (!question6HasValue && !question7HasValue && !question8HasValue) {
      $("#questions678").validationEngine('showPrompt', 'Please select an answer for either question 6, 7, or 8', 'error', 'topLeft', false);
      isValid = false;
   }

   // 9 is required

   var question9_1 = $("[id$='txtYorPRequested1']");
   var question9_2 = $("[id$='txtYorPRequested2']");
   var question9_3 = $("[id$='txtYorPRequested3']");
   var question9_4 = $("[id$='txtYorPRequested4']");
   if ((question9_1.val().length == 0) &&
      (question9_2.val().length == 0) &&
      (question9_3.val().length == 0) &&
      (question9_4.val().length == 0)) {
      $("#question9").validationEngine('showPrompt', 'Please enter at least one year in question 9', 'error', 'topLeft', false);
      isValid = false;
   }

   return isValid;
}
